import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { Select, SelectItem, SelectedItems } from '@backstage/core-components';
import {
  C4DiagramDeploymentNode,
  C4DiagramEntity,
} from '../C4DiagramCard/types';

interface DialogAddDeploymentProps {
  open: boolean;
  components: Array<C4DiagramEntity>;
  resources: Array<C4DiagramDeploymentNode>;
  onClose: () => void;
  onSave: (componentId: string, resourceId: string) => void;
}

export function DialogAddDeployment({
  open,
  components,
  resources,
  onClose,
  onSave,
}: Readonly<DialogAddDeploymentProps>) {
  const [component, setComponent] = useState<SelectedItems>('');
  const [resource, setResource] = useState<SelectedItems>('');
  const [componentItems, setComponentItems] = useState<SelectItem[]>([]);
  const [resourceItems, setResourceItems] = useState<SelectItem[]>([]);

  useEffect(() => {
    initComponentItems();
  }, [components]);

  useEffect(() => {
    initResourceItems();
  }, [resources]);

  function initComponentItems() {
    const filtered = components
      .map(it => {
        return { label: `[${it.type}] ${it.text!}`, value: it.id };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
    setComponentItems(filtered);
    setComponent(filtered && filtered.length > 0 ? filtered[0].value : '');
  }

  function initResourceItems() {
    const filtered = resources
      .map(it => {
        return { label: it.text!, value: it.id };
      })
      .sort((a, b) => a.label.localeCompare(b.label));
    setResourceItems(filtered);
    setResource(filtered && filtered.length > 0 ? filtered[0].value : '');
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add deployment</DialogTitle>
      <DialogContent>
        <Select
          label="Component"
          items={componentItems}
          onChange={(e: SelectedItems) => {
            setComponent(e);
          }}
          multiple={false}
          selected={component}
        ></Select>
      </DialogContent>
      <DialogContent>
        <Select
          label="Resource"
          items={resourceItems}
          onChange={(e: SelectedItems) => {
            setResource(e);
          }}
          multiple={false}
          selected={resource}
        ></Select>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => onSave(component as string, resource as string)}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
